export default __webpack_public_path__ + "static/media/l-desktop.e7ec3d0f.png";